import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './core/modules/shared.module';
import { MainModule } from './main/main.module';
import { AppSplashScreenService } from './core/services/splash-screen.service';
import { AppConfigService } from './core/services/config.service';
import { NavigationService } from './core/components/navigation/navigation.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Error404Component } from './main/errorsPages/404/error-404.component';
import { InterceptorService } from './core/services/rest-call/interceptor.service';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { TranslateApplicationService } from './core/translate/translate-application-service';
import { TranslateService } from './core/services/translate-service';
import { ApplicationInfoService } from './core/translate/application-info.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthenticationGuard, MsAdalAngular6Module, MsAdalAngular6Service } from '@jabilcore/microsoft-adal-angular6';
import { PrimeNGConfig } from 'primeng/api';
import { TranslatePipe } from './core/pipes/translate-pipe';
import { CognitoGuard } from './core/cognito-guard/cognito-guard';
import { CognitoService } from './core/services/cognito/cognito.service';
import { CanActivateAuthGuard } from './auth/can-activate-auth-guard';
import { LoginModule } from './auth/login.module';

function getApplicationInfo(application: ApplicationInfoService) {
  return () => application.loadLanguages();
}

export function setupTranslateFactory(service: TranslateService): Function {
  return () => service.use('es');
}


const initializeAppFactory = (primeConfig: PrimeNGConfig  ) => () => {
  primeConfig.ripple = true;
};

const loginType: number = window["loginType"];

const importsArray = [
  BrowserModule,
  AppRoutingModule,
  HttpClientModule,
  BrowserAnimationsModule,
  SharedModule,
  ReactiveFormsModule,
  ToastrModule.forRoot({
    timeOut: 3000,
    positionClass: "toast-top-right",
  }),
  TranslateModule.forRoot(),
  MainModule,
  LoginModule
];

if (loginType == 1)
  importsArray.push(MsAdalAngular6Module.forRoot({}));

@NgModule({
  declarations: [
    AppComponent,
    Error404Component
  ],
  imports: importsArray,
  providers: [
    AppSplashScreenService,
    AppConfigService,
    NavigationService,
    loginType == 1 ? AuthenticationGuard : [],
    ToastrService,
    DatePipe,
    loginType == 1 ? MsAdalAngular6Service : [],
    CanActivateAuthGuard,
    {
      provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true
    },
    TranslateApplicationService,
    TranslateService,
    loginType == 3 ?
      {
        provide: APP_INITIALIZER,
        useFactory: setupTranslateFactory,
        deps: [TranslateService],
        multi: true
      } :
      {
        provide: APP_INITIALIZER,
        useFactory: getApplicationInfo,
        deps: [ApplicationInfoService],
        multi: true
      },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [PrimeNGConfig],
      multi: true
    },
    CognitoService,
    CognitoGuard
  ],
  bootstrap: [AppComponent],
  exports: [ ]
})
export class AppModule { }
